import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import Bot from "../BottomTab/Bot";
import BottomTab from "../BottomTab/Bot";
import MasterData from "./MasterData";
import Users from "./Users";
import PaymentDrawer from "./PaymentDrawer";
import OperationMan from "./OperationMan";
import Dispatch from "./Dispatch";
import VechicleExpense from "./VechicleExpense";
import VehicleIns from "./VehicleIns";
import ReportDrawer from "./ReportDrawer";
import ConfigDrawer from "./ConfigDrawer";
import { useDrawer } from "./DrawerContext";
import useAppNavigation from "../../Routes/useAppNavigation";
// Your screen components (keep these the same)
const DashboardScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>Dashboard</h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Welcome to the dashboard screen!
    </p>
  </div>
);

// const MasterDataScreen = () => (
//   <div style={{ padding: "20px" }}>
//     <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>Master Data</h1>
//     <p style={{ color: "#666", lineHeight: "1.6" }}>
//       Manage your master data here.
//     </p>
//   </div>
// );

const PaymentScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>Payment</h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Payment processing screen.
    </p>
  </div>
);

const OperationManScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>
      Operation Management
    </h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Operation management screen.
    </p>
  </div>
);

const SettingsScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>
      Dispatch Management
    </h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Dispatch management screen.
    </p>
  </div>
);

const VehicleExpensesScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>Vehicle Expenses</h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Vehicle expenses tracking.
    </p>
  </div>
);

const VehicleInsScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>
      Vehicle Inspection
    </h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>
      Vehicle inspection management.
    </p>
  </div>
);

const ReportScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>Report</h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>Reports and analytics.</p>
  </div>
);

const ConfigurationScreen = () => (
  <div style={{ padding: "20px" }}>
    <h1 style={{ color: "#8B4513", marginBottom: "16px" }}>
      Configuration Checker
    </h1>
    <p style={{ color: "#666", lineHeight: "1.6" }}>System configuration.</p>
  </div>
);

// Menu items configuration with proper image icons
const menuItems = [
  {
    name: "Dashboard",
    component: Bot,
    icon: {
      active: AppImages.BottomDashboard,
      inactive: AppImages.BottomDashboardInactive,
    },
  },
  {
    name: "Master Data",
    component: MasterData,
    icon: {
      active: AppImages.BottomMasterDataActive,
      inactive: AppImages.MasretData,
    },
  },
  {
    name: "Users",
    component: Users,
    icon: {
      active: AppImages.BottomUsersActive,
      inactive: AppImages.Users,
    },
  },
  {
    name: "Payment",
    component: PaymentDrawer,
    icon: {
      active: AppImages.BottomPaymentActive,
      inactive: AppImages.Payment,
    },
  },
  {
    name: "Operation Management",
    component: OperationMan,
    icon: {
      active: AppImages.BottomTripActive,
      inactive: AppImages.TripBottom,
    },
  },
  {
    name: "Dispatch Management",
    component: Dispatch,
    icon: {
      active: AppImages.BottomDispatchManagementActive,
      inactive: AppImages.Dispatch,
    },
  },
  {
    name: "Vehicle Expenses",
    component: VechicleExpense,
    icon: {
      active: AppImages.BottomVehicleExpenceActive,
      inactive: AppImages.VehicleExpence,
    },
  },
  {
    name: "Vehicle Inspection",
    component: VehicleIns,
    icon: {
      active: AppImages.BottomInspection,
      inactive: AppImages.BottomInspectionIns,
    },
  },
  {
    name: "Report",
    component: ReportDrawer,
    icon: {
      active: AppImages.BottomAccontActive,
      inactive: AppImages.Report,
    },
  },
  {
    name: "Configuration checker",
    component: ConfigDrawer,
    icon: {
      active: AppImages.BottomConfigActive,
      inactive: AppImages.Config,
    },
  },
];

export default function DrawerScreen() {
  const [currentScreen, setCurrentScreen] = useState("Dashboard");
  // const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { isDrawerOpen, setIsDrawerOpen } = useDrawer();
  // Drawer screens (Bot/Account/MasterData/...) expect a `navigation` prop.
  // Without it, their header bell calls navigation.navigate(...) on undefined.
  const navigation = useAppNavigation();
  const CurrentScreenComponent =
    menuItems.find((item) => item.name === currentScreen)?.component ||
    DashboardScreen;

  // Inline styles
  const styles = {
    app: {
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
      backgroundColor: "#f5f5f5",
    },
    header: {
      background: "white",
      padding: "16px 20px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      display: "flex",
      alignItems: "center",
      position: "sticky",
      top: 0,
      zIndex: 100,
    },
    menuButton: {
      background: "none",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
      marginRight: "16px",
      padding: "8px",
      borderRadius: "4px",
    },
    headerTitle: {
      color: "#8B4513",
      fontSize: "20px",
      fontWeight: "600",
      margin: 0,
    },
    mainContainer: {
      display: "flex",
      flex: 1,
      position: "relative",
    },
    drawer: {
      position: "fixed",
      top: 0,
      left: isDrawerOpen ? 0 : "-280px",
      width: "280px",
      height: "100vh",
      background: "white",
      boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
      transition: "left 0.3s ease",
      zIndex: 1000,
      overflowY: "auto",
      paddingTop: "70px",
    },
    drawerItem: {
      display: "flex",
      alignItems: "center",
      padding: "12px 20px",
      cursor: "pointer",
      borderLeft: "4px solid transparent",
      transition: "background-color 0.2s",
    },
    drawerItemActive: {
      background: "#F5E6D3",
      borderLeftColor: "#8B4513",
      color: "#8B4513",
      fontWeight: "600",
    },
    drawerIcon: {
      marginRight: "12px",
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    drawerText: {
      fontSize: "14px",
    },
    mainContent: {
      flex: 1,
      padding: "20px",
      background: "white",
      margin: "20px",
      borderRadius: "8px",
      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0,0,0,0.5)",
      zIndex: 999,
    },
  };

  return (
    <div style={styles.app}>
      {/* Header */}
      {/* <header style={styles.header}>
        <button
          style={styles.menuButton}
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
        >
          ☰
        </button>
        <h2 style={styles.headerTitle}>{currentScreen}</h2>
      </header> */}

      <div style={styles.mainContainer}>
        {/* Drawer Sidebar */}
        <aside style={styles.drawer}>
          <nav>
            {menuItems.map((item) => {
              const isActive = currentScreen === item.name;
              const iconSrc = isActive ? item.icon.active : item.icon.inactive;

              return (
                <div
                  key={item.name}
                  style={{
                    ...styles.drawerItem,
                    ...(isActive ? styles.drawerItemActive : {}),
                    backgroundColor: isActive ? "#F5E6D3" : "transparent",
                  }}
                  onClick={() => {
                    setCurrentScreen(item.name);
                    setIsDrawerOpen(false);
                  }}
                  onMouseEnter={(e) => {
                    if (!isActive) {
                      e.target.style.backgroundColor = "#F5E6D3";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isActive) {
                      e.target.style.backgroundColor = "transparent";
                    }
                  }}
                >
                  <div style={styles.drawerIcon}>
                    <img
                      src={iconSrc}
                      alt={`${item.name} icon`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <span style={styles.drawerText}>{item.name}</span>
                </div>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main style={styles.mainContent}>
          <CurrentScreenComponent navigation={navigation} />
        </main>
      </div>

      {/* Overlay */}
      {isDrawerOpen && (
        <div style={styles.overlay} onClick={() => setIsDrawerOpen(false)} />
      )}
    </div>
  );
}
